var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete-single',{attrs:{"name":"Категория пользователя","items":_vm.state.data.items,"select":_vm.localSelect,"loading":_vm.state.loading},on:{"update:select":function($event){_vm.localSelect=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }